export const STREAM_REVEAL_DELAY = 32;

const NORMAL_CHARS = 6;
const CATCH_UP_CHARS = 12;
const EMERGENCY_CHARS = 18;

const advanceByCodePoints = (value, start, count) => {
  let end = start;
  let consumed = 0;
  while (end < value.length && consumed < count) {
    const codePoint = value.codePointAt(end);
    end += codePoint > 0xffff ? 2 : 1;
    consumed += 1;
  }
  return end;
};

export const revealStreamTarget = (displayed = "", target = "") => {
  if (displayed === target) {
    return { value: displayed, done: true, replaced: false };
  }
  if (!target.startsWith(displayed)) {
    return { value: target, done: true, replaced: true };
  }

  const remaining = target.length - displayed.length;
  const revealChars = remaining > 2_000
    ? EMERGENCY_CHARS
    : remaining > 800
    ? CATCH_UP_CHARS
    : NORMAL_CHARS;
  const end = advanceByCodePoints(target, displayed.length, revealChars);
  const value = target.slice(0, end);
  return { value, done: value.length >= target.length, replaced: false };
};
